module.exports = __webpack_public_path__ + "img/diploma.2ad8c1f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/indicateurs-icons/diploma.svg
// module id = xAUX
// module chunks = 7